import Chair from "@mui/icons-material/Chair";
import {
  Box,
  IconButton,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Toolbar } from "common";
import TableSelectorModal from "components/TableSelector/TableSelectorModal";
import useDictionaries from "features/dictionaries/useDictionaries";
import { ProgramItem } from "features/programs/programApi";
import { SeatingLayoutItem } from "features/seating-layouts/seatingLayoutApi";
import moment from "moment";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { HostItem } from "./hostApi";
import OrderItem from "./OrderItem";

const summaryColors = {
  option: "lightblue",
  variant: "lightgreen",
};

function HostListItem({
  item,
  status,
}: {
  item: HostItem;
  status?: string | null;
}) {
  const [open, setOpen] = useState(false);
  const { resolveOption, resolveOptions } = useDictionaries();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [keyword, setKeyword] = useState<string>();
  const [loading, setLoading] = useState(false);

  function load() {}

  /* useEffect(() => {
    if (!!keyword) {
    }
  }, [keyword]);*/

  const renderPrograms = useCallback(() => {
    return (
      <>
        {item.program_ids.map(program_id => {
          const program = resolveOption<ProgramItem>("programs", program_id);
          return (
            <Toolbar key={program_id} sx={{ gap: 1 }}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "5px",
                  backgroundColor: program?.color,
                }}
              />
              <Typography>{program?.name}</Typography>
            </Toolbar>
          );
        })}
      </>
    );
  }, [item.program_ids, resolveOption]);

  // Státusz meghatározása a prop alapján
  const getCateringStatus = useCallback(() => {
    if (status === "running") {
      return { text: " (folyamatban)", color: theme.palette.success.main };
    } else if (status === "next") {
      return { text: " (következő)", color: theme.palette.warning.main };
    } else if (status === "upcoming") {
      return { text: " (hamarosan)", color: theme.palette.primary.main };
    }
    return null;
  }, [status, theme]);

  const cateringStatus = getCateringStatus();

  // Vizuális stílus meghatározása a státusz alapján
  const getItemStyles = useCallback(() => {
    const isFinished = status === "finished";
    return {
      opacity: isFinished ? 0.6 : 1,
      backgroundColor: isFinished ? theme.palette.action.hover : "transparent",
    };
  }, [status, theme]);

  const seatingLayoutIds = Array.from(
    new Set(item.bookings?.flatMap(b => b.seating_layout_ids ?? []) ?? []),
  );
  const seating_layouts = resolveOptions<SeatingLayoutItem>(
    "layouts",
    seatingLayoutIds,
  );
  const reservedTables =
    item.bookings?.flatMap(b => b.table_numbers ?? []) ?? [];

  const summary = item.summary;

  summary.sort((a, b) => b.qty - a.qty);

  return (
    <>
      <ListItemButton
        component={Link}
        to={`${encodeURIComponent(item.start_time)}/${item.boat_id}`}
        state={{
          item,
        }}
        divider
        sx={getItemStyles()}
      >
        <ListItemText
          disableTypography
          primary={
            <Toolbar sx={{ gap: 1, flexWrap: "wrap" }}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: cateringStatus ? 600 : 500,
                  color: cateringStatus?.color || "inherit",
                }}
              >
                {`${moment(item.start_time).format("L LT")} - ${item.boat_name}`}
                {cateringStatus?.text}
              </Typography>
              {renderPrograms()}
            </Toolbar>
          }
          secondary={
            <Box
              display="flex"
              flexDirection="row"
              gap={1}
              mt={1}
              flexWrap="wrap"
            >
              <OrderItem
                name="Vendégek"
                qty={item.guestSummary.total.number_of_guests || 0}
                type="option"
              />
              <OrderItem
                name="Foglalások"
                qty={item.guestSummary.total.number_of_bookings || 0}
                type="option"
              />
              <OrderItem
                name="Megérkezett"
                qty={item.guestSummary.total.guests_arrived}
                type="option"
              />
              <OrderItem
                name="Leültetett"
                qty={item.guestSummary.total.tables_reserved}
                type="option"
              />
            </Box>
          }
        />
        <ListItemSecondaryAction>
          {seatingLayoutIds.length > 0 && (
            <Tooltip title="Asztaltérkép">
              <IconButton
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpen(true);
                }}
              >
                <Chair />
              </IconButton>
            </Tooltip>
          )}
        </ListItemSecondaryAction>
      </ListItemButton>
      {seatingLayoutIds.length > 0 && (
        <TableSelectorModal
          readOnly
          open={open}
          onClose={() => setOpen(false)}
          bookings={item.bookings as any}
          layouts={seating_layouts || []}
          value={[]}
          reserved={reservedTables}
          onChange={() => {}}
          fullWidth
          maxWidth="xl"
        />
      )}
    </>
  );
}

export default HostListItem;
